import { render, staticRenderFns } from "./EVMTxDataTable.vue?vue&type=template&id=74db6ff5&scoped=true&"
import script from "./EVMTxDataTable.vue?vue&type=script&lang=ts&"
export * from "./EVMTxDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./EVMTxDataTable.vue?vue&type=style&index=0&id=74db6ff5&scoped=true&lang=scss&"
import style1 from "./EVMTxDataTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74db6ff5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VDataTable,VSpacer})
